import { DataProductApi } from '../constants/api';
import { useAppSettings } from '../context/AppSettings';

// Setting this hard coded for now.  We don't want to have to import any rip dependencies.
const regionToAirportMappings: Record<string, string> = {
  'us-east-1': 'iad',
  'us-west-1': 'sfo',
  'us-west-2': 'pdx',
  'us-east-2': 'cmh',
};

const constructApiEndpoint =
  (region: string, stage: string) =>
  (prefix: string, apiName: string): string => {
    const airport = regionToAirportMappings[region];
    return `https://${prefix}.${airport}.${stage}.${apiName}.groundstation.aws.dev/graphql`;
  };

export type DataProductEndpoints = Record<DataProductApi, string>;

export const useDataProductEndpoints = (): DataProductEndpoints => {
  const { graphqlApiUrl, region, stage } = useAppSettings();
  const endpointCreator = constructApiEndpoint(region, stage);

  return {
    [DataProductApi.DATA_PLANE_API]: endpointCreator('api', 'agent-dp'),
    [DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API]: endpointCreator('api', 'controlplane-dp'),
    [DataProductApi.CURATED_API]: graphqlApiUrl,
  };
};
